import React, { useEffect, useState } from "react";
import TableFilter from "./tableFilter";
import { PaginationProps } from "../ui/Pagination";
import AdsTable from "./adsTable";
import { Loading } from "../ui";
import { adTypes } from "src/pages/ads/adsLanding";

interface AdsTableParentProps {
	type: string;
	ads: IAdvertisement[];
	isLoading: boolean;
	paginationData: PaginationProps;
	pageNo: number;
	setPageNo: React.Dispatch<React.SetStateAction<number>>;
	callback: () => void;
}

const AdsTableParent = ({
	type,
	ads,
	isLoading,
	pageNo,
	paginationData,
	setPageNo,
	callback,
}: AdsTableParentProps) => {
	const filterList = [
		"All",
		"Active",
		"Completed",
		"Paused",
		"Upcoming",
		"Suspended",
		"Canceled",
	];

	const [filteredAds, setFilteredAds] = useState<IAdvertisement[]>([]);

	useEffect(() => {
		setFilteredAds(ads);
	}, [ads]);

	const adType = adTypes.find((ad) => ad.slug === type);

	useEffect(() => {
		if (ads.length > 0) {
			const newAds = ads.filter((ad) => ad.adType === adType?.slug);
			setFilteredAds(newAds);
		}
	}, [adType, ads]);

	return (
		<div className='bg-white rounded-lg p-4 mt-8'>
			<h2 className='font-semibold capitalize text-xl'>{adType?.label} Ads</h2>
			<TableFilter
				data={ads}
				setFilteredAds={setFilteredAds}
				filterList={filterList}
				type={adType?.slug || ""}
				totalC={paginationData.total}
			/>
			{isLoading ? (
				<div className='flex py-40 items-center justify-center'>
					<Loading />
				</div>
			) : (
				<AdsTable
					paginationData={paginationData}
					pgn={pageNo}
					rows={filteredAds}
					setpgn={setPageNo}
					callback={callback}
				/>
			)}
		</div>
	);
};

export default AdsTableParent;
